import { Location } from '@angular/common';
import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';

import { AssessmentService } from "../../shared/services/assessment.service";
import { Assessment } from "../../shared/models/assessment";
import { AssessmentResult } from "../../shared/models/assessment-result";
import { ScaleResult } from "../../shared/models/scale-result";
import { PrintSettings } from 'app/reports/models/print-settings';
import { Subscription } from 'rxjs/Subscription';
import { DacConfig } from 'app/shared/services/dac-config.service';

@Component({
  selector: 'app-assessment-result-view',
  templateUrl: './assessment-result-view.component.html',
  styleUrls: ['./assessment-result-view.component.css']
})
export class AssessmentResultViewComponent implements OnInit, AfterViewInit {

    private queryParamsSubscription: Subscription;
    private _result:AssessmentResult;
    private _clientId:string;

    public hasLoadedResults:boolean;

  /**
   * Whether to show therapist note information in the report.  Otherwise it's hidden so it can be
   * given to a client or print off a shorter report.
   */
  public displayTherapistNotes:boolean;
  
  /**
   * Whether to show the print dialog or not.
   */
  public showPrintDialog:boolean;

  private _visibleScaleResults:ScaleResult[];

    
    constructor(
      private route:ActivatedRoute
      ,private router:Router
		  ,private _assessmentService:AssessmentService
      ,private location:Location
      ,private elementRef:ElementRef
      ,private dacConfig:DacConfig) {
        this._visibleScaleResults = [];
    }

  showCommandButtons() {
      return !this.dacConfig.seamlessMode;
  }

  ngOnInit() {
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      if (params['notes'] && params['notes'] == '1') {
        this.displayTherapistNotes = true;
      }
      else {
        this.displayTherapistNotes = false;
      }
    });

    
    
    // TODO: stephen do we need the rx switchTo piece?
    this.route.params.subscribe((params) => {
          this._clientId = params['id'];
          let resultId = params['resultId'];
          this.hasLoadedResults = false;
          this._assessmentService.getAssessmentResult(this._clientId, resultId).then((result:AssessmentResult) =>  {
            this.hasLoadedResults = true;
            this.result = result;
            if (this.result == null || !this.result.scaleResults || this.result.scaleResults.length < 1) {
              // this.goBack();
            } else {
              this._visibleScaleResults = this.result.scaleResults.filter(sr => sr.scale && sr.scale.includeInReports === true);
            }
          })
          .catch((error) => {
            console.error(error);
            if (error && error.status === 404 || error.status === 400) {
              // this.goBack();
            }
          });
        });
    }
    
    ngAfterViewInit() {
      // we need to let outside listeners like the server pdf generator know we have finished loading so we can generate the report
      console.log("adding dac-report-loaded class");
      document.body.classList.add("dac-report-loaded");

    }

    ngAfterContentInit() {
    }

    public get scaleResults () {
      return this._visibleScaleResults;
    }


    public goBack() {
      this.location.back();
  }
  
    public get clientID() : string {
        return this._clientId;
    }
    
    public get result() : AssessmentResult {
		return this._result;
	}
	
	public set result(v:AssessmentResult) {
		this._result = v;
  }
  
  public print() {
    this.showPrintDialog = true;
  }

  public closePrintDialog() {
    // reset it once we've closed the dialog.
    this.showPrintDialog = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/reports/assessment-result-view/assessment-result-view.component.ts